var map = {
	"./Bandit": [
		17,
		47
	],
	"./Bandit.js": [
		17,
		47
	],
	"./BanditFight": [
		18,
		46
	],
	"./BanditFight.js": [
		18,
		46
	],
	"./Bonefire": [
		19,
		45
	],
	"./Bonefire.js": [
		19,
		45
	],
	"./BonefireAFight": [
		20,
		44
	],
	"./BonefireAFight.js": [
		20,
		44
	],
	"./BonefireAsleep": [
		21,
		43
	],
	"./BonefireAsleep.js": [
		21,
		43
	],
	"./BonefireAwake": [
		22,
		42
	],
	"./BonefireAwake.js": [
		22,
		42
	],
	"./BonefireAwakeCook": [
		23,
		41
	],
	"./BonefireAwakeCook.js": [
		23,
		41
	],
	"./BonefireNegociate": [
		24,
		40
	],
	"./BonefireNegociate.js": [
		24,
		40
	],
	"./BonefireRunAway": [
		25,
		39
	],
	"./BonefireRunAway.js": [
		25,
		39
	],
	"./BurnedTrees": [
		26,
		38
	],
	"./BurnedTrees.js": [
		26,
		38
	],
	"./BurningTrees2": [
		27,
		37
	],
	"./BurningTrees2.js": [
		27,
		37
	],
	"./DisrespectLakeStatue": [
		28,
		36
	],
	"./DisrespectLakeStatue.js": [
		28,
		36
	],
	"./DiveIntoTheLake": [
		29,
		35
	],
	"./DiveIntoTheLake.js": [
		29,
		35
	],
	"./Elder": [
		30,
		34
	],
	"./Elder.js": [
		30,
		34
	],
	"./ElderFalse": [
		31,
		33
	],
	"./ElderFalse.js": [
		31,
		33
	],
	"./ElderTrue1": [
		32,
		32
	],
	"./ElderTrue1.js": [
		32,
		32
	],
	"./ElderTrue2": [
		33,
		31
	],
	"./ElderTrue2.js": [
		33,
		31
	],
	"./ElderTrue3": [
		34,
		30
	],
	"./ElderTrue3.js": [
		34,
		30
	],
	"./Excuses": [
		35,
		29
	],
	"./Excuses.js": [
		35,
		29
	],
	"./Flambuisiness": [
		36,
		28
	],
	"./Flambuisiness.js": [
		36,
		28
	],
	"./Flamby": [
		37,
		27
	],
	"./Flamby.js": [
		37,
		27
	],
	"./FollowSolarKnight": [
		38,
		26
	],
	"./FollowSolarKnight.js": [
		38,
		26
	],
	"./ForestLeftRoad": [
		39,
		25
	],
	"./ForestLeftRoad.js": [
		39,
		25
	],
	"./ForestLeftRoad2": [
		40,
		24
	],
	"./ForestLeftRoad2.js": [
		40,
		24
	],
	"./ForestLichen": [
		41,
		23
	],
	"./ForestLichen.js": [
		41,
		23
	],
	"./ForestMonster": [
		42,
		22
	],
	"./ForestMonster.js": [
		42,
		22
	],
	"./ForestStairs": [
		43,
		21
	],
	"./ForestStairs.js": [
		43,
		21
	],
	"./GameOver": [
		44,
		20
	],
	"./GameOver.js": [
		44,
		20
	],
	"./GatherFood": [
		45,
		19
	],
	"./GatherFood.js": [
		45,
		19
	],
	"./GhostForest": [
		46,
		18
	],
	"./GhostForest.js": [
		46,
		18
	],
	"./HuntingTrap": [
		47,
		17
	],
	"./HuntingTrap.js": [
		47,
		17
	],
	"./Intro": [
		48,
		16
	],
	"./Intro.js": [
		48,
		16
	],
	"./LakeBottom": [
		49,
		15
	],
	"./LakeBottom.js": [
		49,
		15
	],
	"./LakeStatue": [
		50,
		14
	],
	"./LakeStatue.js": [
		50,
		14
	],
	"./LazarusSpell": [
		51,
		13
	],
	"./LazarusSpell.js": [
		51,
		13
	],
	"./MeetSolarKnight": [
		52,
		12
	],
	"./MeetSolarKnight.js": [
		52,
		12
	],
	"./MuddyWater": [
		53,
		11
	],
	"./MuddyWater.js": [
		53,
		11
	],
	"./PreyLakeStatue": [
		54,
		10
	],
	"./PreyLakeStatue.js": [
		54,
		10
	],
	"./RunAway": [
		55,
		9
	],
	"./RunAway.js": [
		55,
		9
	],
	"./SolarFlare": [
		56,
		8
	],
	"./SolarFlare.js": [
		56,
		8
	],
	"./SolarFlareEsc": [
		57,
		7
	],
	"./SolarFlareEsc.js": [
		57,
		7
	],
	"./SolarKnight": [
		58,
		6
	],
	"./SolarKnight.js": [
		58,
		6
	],
	"./Start": [
		59,
		5
	],
	"./Start.js": [
		59,
		5
	],
	"./StealSunHelm": [
		60,
		4
	],
	"./StealSunHelm.js": [
		60,
		4
	],
	"./Temple": [
		61,
		3
	],
	"./Temple.js": [
		61,
		3
	],
	"./TradeChapkaForSunHelm": [
		62,
		2
	],
	"./TradeChapkaForSunHelm.js": [
		62,
		2
	],
	"./TradeChapkaFree": [
		63,
		1
	],
	"./TradeChapkaFree.js": [
		63,
		1
	],
	"./Upstairs": [
		64,
		0
	],
	"./Upstairs.js": [
		64,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 16;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/content lazy ^\.\/.*$
// module id = 16
// module chunks = 48